<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <h1 :class="b('title')">
      {{ $t("Пользователи") }}
    </h1>

    <div :class="b('balances')">
      <AdminBalanceCard
        :class="b('balance-card')"
        :user-id="inUserId"
        label="IN"
      />
      <AdminBalanceCard
        :class="b('balance-card')"
        :user-id="outUserId"
        label="OUT"
      />
    </div>

    <div :class="b('wrapper')">
      <AdminUsersFilter
        v-model:value="search.value"
        v-model:type="search.type"
        v-model:status="search.status"
      />

      <AdminUsersTable
        :class="b('table')"
        :search="search"
        :sort="sort"
        v-model:is-status="isStatus"
        v-model:is-balance="isBalance"
      />

      <!-- <SharedButtonIcon
        v-if="isMoreShow"
        :class="b('more')"
        view="gray-outline"
        @click="handleMore"
      >
        <template #icon-left>
          <span :class="b('more-icon')" v-html="displayedIcons.more"></span>
        </template>

        <template #label>
          {{ $t("Показать больше") }}
        </template>
      </SharedButtonIcon> -->
      <div :class="b('pagination')">
        <span
          :class="b('pagination-item', { active: sort.page == 1 })"
          @click="goToPage(1)"
          >1</span
        >
        <span v-if="sort.page > 4" :class="b('pagination-item', { dots: true })"
          >...</span
        >
        <span
          v-if="sort.page - 2 > 1"
          :class="b('pagination-item')"
          @click="goToPage(sort.page - 2)"
          >{{ sort.page - 2 }}</span
        >
        <span
          v-if="sort.page - 1 > 1"
          :class="b('pagination-item')"
          @click="goToPage(sort.page - 1)"
          >{{ sort.page - 1 }}</span
        >
        <span
          v-if="sort.page != 1 && sort.page != lastPage"
          :class="b('pagination-item', { active: true })"
          @click="goToPage(sort.page)"
          >{{ sort.page }}</span
        >
        <span
          v-if="sort.page + 1 < lastPage"
          :class="b('pagination-item')"
          @click="goToPage(sort.page + 1)"
          >{{ sort.page + 1 }}</span
        >
        <span
          v-if="sort.page + 2 < lastPage"
          :class="b('pagination-item')"
          @click="goToPage(sort.page + 2)"
          >{{ sort.page + 2 }}</span
        >
        <span
          v-if="sort.page < lastPage - 3"
          :class="b('pagination-item', { dots: true })"
          >...</span
        >
        <span
          v-if="lastPage != 1"
          :class="b('pagination-item', { active: sort.page == lastPage })"
          @click="goToPage(lastPage)"
          >{{ lastPage }}</span
        >
      </div>
    </div>

    <transition name="opacity">
      <AdminUsersStatus
        v-if="isStatusShow"
        :class="b('modal')"
        v-model:isStatus="isStatus"
      />
    </transition>

    <transition name="opacity">
      <AdminUsersBalance
        v-if="isBalanceShow"
        :class="b('modal')"
        v-model:isBalance="isBalance"
      />
    </transition>
  </div>
</template>
